var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',{staticClass:"section"},[(!_vm.authorized)?_c('alert',{attrs:{"alertType":"success","message":"You've successfully logged out"}}):_c('alert',{attrs:{"alertType":"warn","message":"Logging you out..."}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }